import type { AgentMode } from "./runner/types";

const key = (companyId: string) => `binaleAgent.mode.${companyId}`;

/** The mode last chosen for the company in this browser; approval when unset or unreadable. */
export const readAgentMode = (companyId: string): AgentMode => {
    try {
        return localStorage.getItem(key(companyId)) === "quick" ? "quick" : "approval";
    } catch {
        return "approval";
    }
};

export const writeAgentMode = (companyId: string, mode: AgentMode): void => {
    try {
        localStorage.setItem(key(companyId), mode);
    } catch {
        // Storage may be blocked; the choice then lasts for this run only.
    }
};
